export const common = {
    // Navigation
    nav: {
        home: 'Home',
        products: 'Products',
        about: 'About',
        contact: 'Contact',
        cart: 'Cart',
        account: 'Account',
    },
    // Actions
    actions: {
        add: 'Add',
        remove: 'Remove',
        edit: 'Edit',
        delete: 'Delete',
        create: 'Create',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        search: 'Search',
        filter: 'Filter',
        sort: 'Sort',
        apply: 'Apply',
        clear: 'Clear',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        loading: 'Loading...',
        close: 'Close',
    },
    // Messages
    messages: {
        success: 'Operation completed successfully',
        error: 'An error occurred',
        notFound: 'Not found',
        unauthorized: 'Unauthorized',
        forbidden: 'Access denied',
        validationError: 'Validation error',
        networkError: 'Connection error',
        tryAgain: 'Try again',
    },
    // Form labels
    form: {
        email: 'Email',
        password: 'Password',
        name: 'Name',
        phone: 'Phone',
        address: 'Address',
        city: 'City',
        state: 'State',
        zip: 'ZIP Code',
        country: 'Country',
        required: 'Required',
        optional: 'Optional',
    },
    // Common terms
    common: {
        price: 'Price',
        quantity: 'Quantity',
        total: 'Total',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        discount: 'Discount',
        free: 'Free',
        outOfStock: 'Out of stock',
        inStock: 'In stock',
        available: 'Available',
        unavailable: 'Unavailable',
        allRightsReserved: 'All rights reserved',
    },
};
//# sourceMappingURL=common.js.map